/**
 * Shared transition constants for sidebar and main panel synchronization
 * These ensure smooth, synchronized animations when toggling the sidebar
 */

// Transition duration in seconds
export const SIDEBAR_TRANSITION_DURATION = "0.3s";

// Transition timing function - using cubic-bezier for smooth, natural easing
// This provides smooth acceleration and deceleration (ease-in-out effect)
export const SIDEBAR_TRANSITION_TIMING = "cubic-bezier(0.4, 0, 0.2, 1)";

// Combined transition string for width-based transitions
export const SIDEBAR_WIDTH_TRANSITION = `width ${SIDEBAR_TRANSITION_DURATION} ${SIDEBAR_TRANSITION_TIMING}`;

// Combined transition string for sidebar (includes width, max-width, and padding)
export const SIDEBAR_FULL_TRANSITION = `width ${SIDEBAR_TRANSITION_DURATION} ${SIDEBAR_TRANSITION_TIMING}, max-width ${SIDEBAR_TRANSITION_DURATION} ${SIDEBAR_TRANSITION_TIMING}, padding ${SIDEBAR_TRANSITION_DURATION} ${SIDEBAR_TRANSITION_TIMING}`;
